import axios from 'axios';
import getApiUrl from './apiUrl';

const API_BASE_URL = getApiUrl();

function getAccessToken() {
  return localStorage.getItem('token');
}

function Client() {
  return axios.create({
    baseURL: API_BASE_URL,
    timeout: 30000,
    headers: { Authorization: `Bearer ${getAccessToken()}` }
  });
}

function buildFormData(attachable_id, attachable_type, files, attachment_type, importData = null) {
  let formData = new FormData();
  formData.append('files[attachable_type]', attachable_type);
  
  if (attachment_type) {
    formData.append('files[attachment_type]', attachment_type);
  }

  if (importData) {
    formData.append('files[import_type]', 'import_from_svg');
    formData.append('files[import_data]', JSON.stringify(importData));
  }

  const attachable_ids_arr = Array.isArray(attachable_id) ? attachable_id : [attachable_id];
  for (let i = 0; i < attachable_ids_arr.length; i++) {
    formData.append('files[attachable_id][]', attachable_ids_arr[i]);
  }

  for (let i = 0; i < files.length; i++) {
    formData.append('files[files_data][]', files[i]);
  }
  
  return formData;
}

export function UploadFiles(attachable_id, attachable_type, files, options = {}, attachment_type = '', importData = null) {
  return Client().post('/uploads', buildFormData(attachable_id, attachable_type, files, attachment_type, importData), options)
    .then(response => response.data);
}

export function UploadOrReplaceFiles(attachable_id, attachable_type, files, options = {}, attachment_type = '', importData = null) {
  return Client().put('/uploads', buildFormData(attachable_id, attachable_type, files, attachment_type, importData), options)
    .then(response => response.data);
}

export const acceptedFiles = 'image/png,image/jpeg,application/pdf,image/vnd.dwg,application/dwg,drawing/dwg,.dwg,image/svg+xml';
export const acceptedFilesIcons = ['png', 'jpg', 'jpeg', 'pdf', 'dwg', 'svg'];

export default UploadFiles;